__turbopack_context__.v({
  "annotationColorItem": "AnnotationColorItem-module__07K6Fq__annotationColorItem",
  "annotationColorItemBlack": "AnnotationColorItem-module__07K6Fq__annotationColorItemBlack",
  "annotationColorItemBlue": "AnnotationColorItem-module__07K6Fq__annotationColorItemBlue",
  "annotationColorItemGreen": "AnnotationColorItem-module__07K6Fq__annotationColorItemGreen",
  "annotationColorItemRed": "AnnotationColorItem-module__07K6Fq__annotationColorItemRed",
  "annotationColorItemSelected": "AnnotationColorItem-module__07K6Fq__annotationColorItemSelected",
});
